export default __webpack_public_path__ + "static/media/logoHeader2026.4a70129a.png";